module.exports = __webpack_public_path__ + "static/media/Klarna_logo.27d52c33.svg";